import { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

const translations = {
  header: {
    menu: { fr: 'Menu', en: 'Menu' },
    visitUs: { fr: 'Nous Trouver', en: 'Visit Us' },
  },
  hero: {
    tagline: { fr: 'Cafe - Comptoir Viet', en: 'Cafe - Vietnamese Counter' },
    subtitle: {
      fr: 'Saveurs vietnamiennes authentiques dans un espace moderne. Bánh mì frais, bols signature et boissons artisanales.',
      en: 'Authentic Vietnamese flavours in a modern space. Fresh bánh mì, signature bowls, and craft drinks.',
    },
    cta: { fr: 'Voir le Menu', en: 'View Menu' },
  },
  menu: {
    sectionLabel: { fr: 'Nos Plats', en: 'Our Offerings' },
    sectionTitle: { fr: 'Le Menu', en: 'The Menu' },
    perUnit: { fr: '/ unité', en: '/ unit' },
    petit: { fr: 'Petit', en: 'Small' },
    grand: { fr: 'Grand', en: 'Large' },
    vegetarian: { fr: 'Végétarien', en: 'Vegetarian' },
  },
  qr: {
    label: { fr: 'Sur Place', en: 'Dine-in' },
    title: { fr: 'Menu sur votre téléphone', en: 'Menu on your phone' },
    description: {
      fr: 'Scannez le code QR pour consulter notre menu complet directement depuis votre table.',
      en: 'Scan the QR code to browse our full menu right from your table. No app required.',
    },
  },
  contact: {
    label: { fr: 'Nous Trouver', en: 'Find Us' },
    title: { fr: 'Venez Nous Voir', en: 'Visit Us' },
    address: { fr: 'Adresse', en: 'Address' },
    phone: { fr: 'Téléphone', en: 'Phone' },
    hours: { fr: 'Heures d\'ouverture', en: 'Opening Hours' },
    days: {
      'Monday - Friday': { fr: 'Lundi - Vendredi', en: 'Monday - Friday' },
      'Saturday': { fr: 'Samedi', en: 'Saturday' },
      'Sunday': { fr: 'Dimanche', en: 'Sunday' },
    },
  },
  footer: {
    subtitle: { fr: 'Cafe - Comptoir Viet', en: 'Cafe - Vietnamese Counter' },
    copyright: { fr: 'Tous droits réservés.', en: 'All rights reserved.' },
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('fr');
  const toggle = () => setLang((l) => (l === 'fr' ? 'en' : 'fr'));
  const t = (path) => {
    const keys = path.split('.');
    let val = translations;
    for (const k of keys) {
      val = val?.[k];
    }
    return val?.[lang] || path;
  };
  return (
    <LanguageContext.Provider value={{ lang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
